import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import Page from "~Common/Page";
import { LoadingState, SelectStartupItem } from "../components";
import { useFetchUserOrganizations } from "../hooks";
import type { StartupItem } from "../types/startupItem";
import { transformUserOrganization } from "./utilities";

const SelectOrganizationPage = () => {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const { customerId } = useParams();

  const { isLoading, data: organizations = [] } = useFetchUserOrganizations();

  const transformedOrganizations = useMemo<StartupItem[]>(() => {
    let filteredOrgs = organizations;
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      filteredOrgs = organizations.filter(
        ({ organizationId, nameLocal }) =>
          organizationId.toLowerCase().includes(searchTextLower) || nameLocal.toLowerCase().includes(searchTextLower),
      );
    }

    return filteredOrgs.map(transformUserOrganization);
  }, [searchText, organizations]);

  const handleGoBackToCustomerSelection = () => navigate("/");
  const handleSelectOrganization = (selectedOrgId) => {
    const org = organizations.find(({ organizationId }) => organizationId === selectedOrgId);
    if (org) {
      navigate(`/${customerId}/admin/${org.sport}/${org.organizationId}/dashboard`);
    }
  };

  if (isLoading) {
    return <LoadingState />;
  }

  return (
    <Page
      title={<FormattedMessage id="pageTitles.selectOrganization" />}
      subtitle={<FormattedMessage id="organizations.available" />}
      backButtonTextKey="back.to.customer.selection"
      onBack={handleGoBackToCustomerSelection}
    >
      <SelectStartupItem
        handleSelect={handleSelectOrganization}
        searchText={searchText}
        setSearchText={setSearchText}
        startupItemList={transformedOrganizations}
      />
    </Page>
  );
};

export default SelectOrganizationPage;
